// pubsub.ts
type Callback<T = any> = (data: T) => void;

class PubSub {
  private events: Map<string, Set<Callback>> = new Map();

  subscribe<T = any>(event: string, callback: Callback<T>): () => void {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event)!.add(callback);

    // Return unsubscribe function
    return () => {
      this.events.get(event)!.delete(callback);
    };
  }

  publish<T = any>(event: string, data: T): void {
    if (!this.events.has(event)) return;
    for (const callback of Array.from(this.events.get(event)!)) {
      callback(data);
    }
  }
}

export const pubsub = new PubSub();

export const PubSubKeys = {
  LOGOUT: "logout",
};
